import { render } from "./CometChatSharedMediaView.vue?vue&type=template&id=02725606&scoped=true"
import script from "./CometChatSharedMediaView.vue?vue&type=script&lang=js"
export * from "./CometChatSharedMediaView.vue?vue&type=script&lang=js"

import "./CometChatSharedMediaView.vue?vue&type=style&index=0&id=02725606&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02725606"]])

export default __exports__